import {
  PointCloudStylingElevation,
  PointCloudStylingUOM,
} from '@trimble/types';

export const POINT_CLOUD_ELEVATION_DEFAULTS = {
  reference: undefined,
  tolerance: 1,
  offset: 0,
  bandCount: 1,
} as const;

export interface PointCloudElevationControlProps
  extends Partial<PointCloudStylingElevation> {
  uom: PointCloudStylingUOM;
  elevationPicking: boolean;
  elevationPicked: number;
  onReferenceChange?(reference: number): void;
  onToleranceChange?(tolerance: number): void;
  onOffsetChange?(offset: number): void;
  onBandCountChange?(bandCount: number): void;
  onElevationPickingToggle?(enabled: boolean): void;
}
